import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setNextPage, setAuthenticatedUser } from '../../../shared/actions';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import P from '../pages';
import Redirector from '../routes/Redirector';
import FirebaseCreateAccountForm from './FirebaseCreateAccountForm';
import FirebaseEmailVerificationCheck from '../../../shared/components/Firebase/FirebaseEmailVerificationCheck';
import withDefaults from './withDefaults';

const FirebaseRegisterForm = ({ page, content, intl, intl: { formatMessage } }) => {
  const thisPage = P.FIREBASE_REGISTER_FORM_PAGE
  const authenticatedUser = useSelector(state => state.authenticatedUser)
  const dispatch = useDispatch()
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const [checkingToken, setCheckingToken] = useState(token ? true : false)
  const [emailVerified, setEmailVerified] = useState(null)

  const onEmailVerified = () => {
    dispatch(setNextPage(true))
  }

  useEffect(() => {
    if (Object.keys(authenticatedUser).length > 0) return
    if (!token) return;

    const signInWithToken = async () => {fetch('/users/sign_in_with_token', {
        method: 'post',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ token: token })
      }).then(async (resp) => {
        const data = await resp.json()

        if (data.success) {
          dispatch(setAuthenticatedUser(data.authenticated_user));

          if (!data.authenticated_user.email_verified) {
            setCheckingToken(false)
            setEmailVerified(false)
            return
          }

          dispatch(setNextPage(true))
        } else {
          setCheckingToken(false)
        }
      })
    }

    signInWithToken()
  }, [token])

  useEffect(() => {
    if (Object.keys(authenticatedUser).length == 0) return

    if (authenticatedUser.email_verified) {
      dispatch(setNextPage(true))
    } else {
      setCheckingToken(false)
      setEmailVerified(false)
    }
  }, [])


  return (
    <>
      <Redirector this_page={P.FIREBASE_REGISTER_FORM_PAGE} page={page}/>

      {(checkingToken) ? (
        <LoadingSpinner />
      ) : (
        <div className="register_form" style={{ display: checkingToken ? 'none' : 'block' }}>
          {emailVerified !== false ? (
            <FirebaseCreateAccountForm page={page} intl={intl} content={content} setEmailVerified={setEmailVerified} />
          ) : (
            <FirebaseEmailVerificationCheck intl={intl} subject='guest' onEmailVerified={onEmailVerified} />
          )}
        </div>
      )}
    </>
  )
}

FirebaseRegisterForm.propTypes = {
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default withDefaults(FirebaseRegisterForm);
